import { render, staticRenderFns } from "./QuestionResponseText.vue?vue&type=template&id=1f1ba233&scoped=true&"
import script from "./QuestionResponseText.vue?vue&type=script&lang=js&"
export * from "./QuestionResponseText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1ba233",
  null
  
)

export default component.exports